module.exports = __webpack_public_path__ + "static/media/s.fa29f210.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/s.mp3
// module id = 108
// module chunks = 0